import { Box, FormControl, makeStyles } from '@material-ui/core';
import React from 'react';
import { Text } from '../..';
const useStyles = makeStyles(({ spacing }) => ({
    marginDense: {
        margin: `${spacing(0, 0)} !important`,
    },
}));
export function TextField(props) {
    const classes = useStyles();
    const { input, meta, validateFirst, helperText, ...rest } = props;
    const isInvalid = validateFirst ? meta.invalid : meta.touched && meta.invalid;
    const inputHelper = isInvalid ? meta.error : props.helperText;
    const handleChange = ({ target }) => {
        input.onChange(target && target.value);
    };
    const handleClear = () => {
        input.onChange('');
    };
    const handleFocus = () => {
        input.onFocus();
    };
    const handleBlur = () => {
        input.onBlur();
    };
    return (React.createElement(Box, { mb: 1 },
        React.createElement(FormControl, { component: "fieldset", fullWidth: true, classes: { marginDense: classes.marginDense } },
            React.createElement(Text, Object.assign({ value: input.value, error: isInvalid, validateFirst: validateFirst, helperText: inputHelper, onChange: handleChange, onClear: handleClear, onFocus: handleFocus, onBlur: handleBlur }, rest)))));
}
//# sourceMappingURL=TextField.js.map